module.exports = __webpack_public_path__ + "img/venuethree-zrw-title.e714fab5.png";